<div class="artist-combined">
  <div class="spacer-fixed-vertical-12"></div>

  <!-- 直近 5 track -->
  <app-recent-track-trends></app-recent-track-trends>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- 最近のプロジェクト動向 -->
  <app-recent-project-trend></app-recent-project-trend>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- 集計サマリー -->
  <app-aggregated-amounts></app-aggregated-amounts>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- ツイッタータグクラウド -->
  <app-twitter-tag-cloud></app-twitter-tag-cloud>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- Unit 数 -->
  <app-units-graph></app-units-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- Stream 数 -->
  <app-streams-graph></app-streams-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- YouTube -->
  <app-youtube-graph></app-youtube-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- フィジカル消化 Unit 数 -->
  <app-physicals-graph></app-physicals-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- Download Unit 数 -->
  <app-download-units-graph></app-download-units-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- Tiktok -->
  <app-tiktok-graph></app-tiktok-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- ネット反応数 -->
  <app-reactions-graph></app-reactions-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- PR Analyzer -->
  <app-pr-analyzer-graph></app-pr-analyzer-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- ホームページ ページビュー数 -->
  <app-homepages-graph></app-homepages-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- ホームページ ユーザ数 -->
  <app-homepages-user-graph></app-homepages-user-graph>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- チャート動向 -->
  <app-charts></app-charts>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- 直近 5 作品動向 -->
  <app-recent-project-trends></app-recent-project-trends>

  <div class="spacer-fixed-vertical-48"></div>

  <!-- デモグラフィック（男女比） -->
  <app-audience></app-audience>

  <div class="spacer-fixed-vertical-48"></div>

  <app-copyright></app-copyright>
</div>
